import { IAuditNode } from '@alberta/konexi-shared';
import { CrossTherapyArticleLineViewModel } from 'src/app/business/cross-therapy/cross-therapy-article-line-view-model';

export function crossTherapyArticleDataIsValid(node: IAuditNode): boolean {
  if (!Array.isArray(node.responses?.[0]?.value)) {
    return true;
  }
  const hideIdentificationNumbers = Boolean(node.options?.hideIdentificationNumbers);
  const validator = new ArticleLineValidator(node.responses?.[0]?.value);
  if (validator.checkQuantity()) {
    return false;
  } else if (validator.checkSerialNumbers(hideIdentificationNumbers)) {
    return false;
  } else if (validator.checkBatchNumbers(hideIdentificationNumbers)) {
    return false;
  }
  return true;
}

class ArticleLineValidator {
  constructor(private articleLines: CrossTherapyArticleLineViewModel[]) {}
  public checkQuantity(): boolean {
    return this.articleLines.every(articleLine => articleLine.quantity < 1);
  }

  public checkSerialNumbers(hideIdentificationNumbers: boolean): boolean {
    const serialNumberArticleLines = this.articleLines.filter(
      articleLine => articleLine.quantity > 0 && articleLine.article.requiresSerialnumber
    );
    if (serialNumberArticleLines.length === 0) {
      return false;
    }
    return serialNumberArticleLines.some(articleLine =>
      this.checkIfArticleInvalid(articleLine, hideIdentificationNumbers)
    );
  }

  public checkBatchNumbers(hideIdentificationNumbers: boolean): boolean {
    if (hideIdentificationNumbers) {
      return false;
    }
    const batchNumberArticlesLines = this.articleLines.filter(
      articleLine => articleLine.quantity > 0 && articleLine.article.requiresBatchnumber
    );
    if (batchNumberArticlesLines.length === 0) {
      return false;
    }
    return batchNumberArticlesLines.some(articleLine => !articleLine.batchNumber);
  }

  private checkIfArticleInvalid(articleLine: CrossTherapyArticleLineViewModel, hideIdentificationNumbers: boolean) {
    if (articleLine.operatingHours?.toString().length > 6) {
      return true;
    }
    if (hideIdentificationNumbers) {
      return false;
    }
    return !articleLine.serialNumber || !articleLine.operatingHours;
  }
}
